import { Copy } from 'lucide-react';

interface ToolCallContentBoxProps {
  content: string;
}

export function ToolCallContentBox({ content }: ToolCallContentBoxProps) {
  const handleCopy = () => {
    navigator.clipboard.writeText(content);
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4 relative">
      <pre className="text-sm text-gray-700 whitespace-pre-wrap break-words pr-8">{content}</pre>
      <button
        onClick={handleCopy}
        className="absolute top-2 right-2 p-1 hover:bg-gray-200 rounded transition-colors"
        title="Copy content"
      >
        <Copy className="w-4 h-4 text-gray-500" />
      </button>
    </div>
  );
}
